import { graphql } from '@/gql';
import type { ScheduledGroceriesQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchScheduledGroceries = async (variables: ScheduledGroceriesQueryVariables) => {
  const response = await queryExecute({
    query: graphql(`
      query ScheduledGroceries(
        $pagination: PaginationInputType
        $phoneNumber: String
        $scheduledGroceryId: Float
        $startDate: String
        $endDate: String
        $isActive: Boolean
        $isCanceled: Boolean
        $isFinished: Boolean
        $isSingle: Boolean
        $isRepeated: Boolean
        $sort: String
      ) {
        scheduledGroceries(
          phoneNumber: $phoneNumber
          pagination: $pagination
          startDate: $startDate
          endDate: $endDate
          scheduledGroceryId: $scheduledGroceryId
          isActive: $isActive
          isCanceled: $isCanceled
          isFinished: $isFinished
          isSingle: $isSingle
          isRepeated: $isRepeated
          sort: $sort
        ) {
          rows {
            id
            callerId
            groceryStoreId
            isMultiple
            scheduleTime
            scheduleDate
            endOn
            timeZone
            endAfterXTimes
            day0
            day1
            day2
            day3
            day4
            day5
            day6
            repeatEveryXWeek
            streetAddress
            streetAddress2
            city
            state
            zip
            country
            latitude
            longitude
            address
            tip
            isLeaveAtDoor
            noteToShopper
            completedAt
            executedAt
            preauthorizedChargeAt
            minutesBeforeCustomReminder
            calledCustomReminderAt
            emailedReminderAt
            calledReminderAt
            emailedUnpaidServicesAt
            calledUnpaidServicesAt
            emailedPreauthFailedAt
            calledPreauthFailedAt
            canceledAt
            cancellationReason
            canceledById
            operatorId
            skipScheduledGroceryDates
            localScheduleTimeDisplayString
            updatedAt
            createdAt
            dateTimes
            groceries {
              orderId
              createdAt
            }
            caller {
              id
              firstName
              lastName
            }
            operator {
              id
              firstName
              lastName
            }
            canceledByUser {
              id
              firstName
              lastName
              roles
              role
            }
            store {
              id
              name
              logo
            }
            storeItems {
              id
              scheduledGroceryId
              groceryItemId
              replacementItemId
              replacementItemQty
              qty
              instruction
              replacementPolicy
              groceryItem {
                id
                name
                img
                unit
                size
                price
                productId
                productName
                createdAt
                updatedAt
                itemId
                groceryProduct {
                  id
                  name
                  createdAt
                  updatedAt
                }
              }
              replacementItem {
                id
                name
                img
                unit
                size
                price
                productId
                productName
                createdAt
                updatedAt
                itemId
                groceryProduct {
                  id
                  name
                  createdAt
                  updatedAt
                }
              }
            }
          }
          count
        }
      }
    `),
    variables,
    fetchPolicy: 'no-cache',
  });

  return response.data.scheduledGroceries;
};
